import React, { Fragment } from 'react';
import Works from './home_components/works'
import Specialized from './home_components/specialized'
import Hackathons from './home_components/hackathons'
import Projects from './home_components/projects'
import { LazyLoad, SeoHelmet } from '../common/Functions'

function Home() {
  return (
  <Fragment>
    <div className="max-w-screen-xl	mx-auto">
      <SeoHelmet title="Product Designer" description="I'm a product designer based in Rizal, Philippines with four and half years of experience in conceptualizing end-to-end UI/UX design process for software products. I've worked with cross-functional teams throughout the design and development process to create better and innovative solutions." />
      <main className="mt-32">
        <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
          <div className="lg:w-5/12 md:w-full lg:order-last md:order-first sm:order-first flex items-center justify-center transform hover:-translate-y-5 transition ease-in-out duration-700">
            <LazyLoad className="inline" src={require('../common/images/loisy_dp.png')} alt="Loisy Profile"/>
          </div>
          <div className="lg:w-7/12 md:w-full inline-flex lg:justify-end ml-5 lg:ml-0">
            <div className="content">
              <p className="text-left font-bold text-2xl">
                Hello, I'm Loisy! 
              </p>
              <p className="text-left text-lg text-gray-600">
                I'm a product designer based in Rizal, Philippines with four and half years of experience in conceptualizing end-to-end UI/UX design process for software products. I've worked with cross-functional teams throughout the design and development process to create better and innovative solutions.
              </p>
              <div className="flex flex-row items-center text-base mt-10">
                <a href="https://ph.linkedin.com/in/eloisa-mae-salvacion" target="blank" className="mr-5">
                  <img src={require('../common/images/home/linkedin.svg')} className="w-8" alt="LinkedIn Logo"/>
                </a>
                <a href="https://dribbble.com/eloisamaesalvacion" target="blank" className="mr-5">
                  <img src={require('../common/images/home/dribbble.svg')} className="w-8" alt="Dribble Logo"/>
                </a>
                <a href="https://www.behance.net/loisaweeeh" target="blank">
                  <img src={require('../common/images/home/behance.svg')} className="w-8" alt="Behance Logo"/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <Specialized />
    <Works />
    <Hackathons />
    <Projects />
  </Fragment>
  );
}

export default Home;
